export default "/images/1300c90615ad0c6b7c3ebc0081ba169f.avif";